import { SendPaymentPageContent } from "Components/Customer/SendPayment/SendPaymentPageContent";
import { AuthenticatedLayout } from "Components/Layout/AuthenticatedLayout";
import { StyledPageWrapper } from "Components/Shared/StyledComponents";
import { useSearchParams } from "Navigation/useSearchParams";
import { Resources, useResource } from "Translations/Resources";
import { appUrl } from "Utils/UrlUtils";

export const SendPaymentPage = () => {
  const { t } = useResource();
  const [searchParams] = useSearchParams();

  const publicID = searchParams.get("publicID");

  return (
    <AuthenticatedLayout
      title={t(Resources.Customer.Pay.ManualEntry.Title)}
      backNavigation={{
        mode: "staticUrl",
        url: appUrl("dashboard"),
      }}
    >
      <StyledPageWrapper>
        <SendPaymentPageContent publicID={publicID} />
      </StyledPageWrapper>
    </AuthenticatedLayout>
  );
};

export default SendPaymentPage;
